import { edtiorUISlice } from './reducers';

export const { addMouseTooltip } = edtiorUISlice.actions;
